/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React from 'react'

import { getMarginInRems } from '../../utils/style/separator'
import { useHideOn } from '../../utils/contexts/ResponsiveProvider'
import { COLORS } from '@btime/constants'

const Separator = ({ vertical, weight, bgColor, hideOn, line }) => {
  if (useHideOn(hideOn)) return false
  const style = css`
		padding-${vertical ? 'left' : 'top'}: ${getMarginInRems(weight)}rem;
		${bgColor ? `background: ${bgColor};` : ''}
    ${line ? `border-top: 1px solid ${COLORS.light3};` : ''}
	`

  return <div css={style} />
}

export default Separator
